// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3fd963f3","643":"495e6748","703":"72878675","787":"a209a0ac"}[chunkId] + ".chunk.js";
};